module.exports = __webpack_public_path__ + "img/3.6d451d9c.gif";